<header class="receiving-picker-header" *ngIf="receivingMode">
  <div><h2><mat-icon>add_box</mat-icon> Добавить товар в приёмку</h2><p>Выберите товар — 1 шт. добавится в черновик. Количество можно изменить в таблице.</p></div>
  <button mat-icon-button type="button" (click)="closeRequested.emit()" aria-label="Закрыть поиск товара"><mat-icon>close</mat-icon></button>
</header>
<div class="wrapper" [class.compactSearchPanel]="compactSearchPanel" [class.receiving-picker]="receivingMode">
  <form [formGroup]="searchForm" class="searchForm" (keydown)="onSearchKeyboard($event)" (ngSubmit)="search()">
    <h3 class="picker-panel-title" *ngIf="receivingMode"><mat-icon>filter_list</mat-icon> Фильтры</h3>
    <mat-form-field appearance="outline">
      <mat-label>Наименование</mat-label>
      <input matInput placeholder="Наименование" formControlName="description" />
    </mat-form-field>
    <app-brand-selector [control]="brandControl"></app-brand-selector>
    <mat-form-field appearance="outline">
      <mat-label>Артикул</mat-label>
      <input matInput cdkFocusInitial #articleInput placeholder="Артикул" formControlName="article" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Штрихкод</mat-label>
      <input matInput placeholder="Штрихкод" formControlName="barcode" />
    </mat-form-field>
    <div class="btnHolder">
      <button mat-flat-button color="primary" type="submit" [disabled]="receivingMode && loading">
        <mat-icon> search </mat-icon>
        Поиск
      </button>
      <button mat-flat-button color="primary" (click)="create()" type="button" [disabled]="receivingMode && loading">
        <mat-icon> add </mat-icon>
        Создать
      </button>
    </div>
    <p class="keyboard-help" *ngIf="keyboardMode">
      Enter в поиске — найти · ↑/↓ — выбрать товар · Enter в строке — добавить товар · Esc — вернуться
    </p>
  </form>

  <div class="tableWrapper">
    <h3 class="picker-panel-title" *ngIf="receivingMode"><mat-icon>inventory_2</mat-icon> Товары <span>{{dataSource.data.length}}</span></h3>
    <p class="picker-message picker-error" *ngIf="receivingMode && searchError" role="alert">{{searchError}}</p>
    <p class="picker-message" *ngIf="receivingMode && !loading && !searchError && !dataSource.data.length" role="status">
      {{searched ? 'Товары не найдены. Проверьте артикул или попробуйте поиск по наименованию, бренду либо штрихкоду.' : 'Введите артикул, наименование, бренд или штрихкод и нажмите «Поиск».'}}
    </p>
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" class="prod-select-table">
        <ng-container matColumnDef="mobileDescriptionAddAnalgoue">
          <th mat-header-cell *matHeaderCellDef>Информация</th>
          <td mat-cell *matCellDef="let product">
            <div class="mobileWrapper">
              <div class="mobileDescription">
                <p class="description">{{ product.description }}</p>
              </div>
              <div class="mobileMainInfoHolder">
                <p class="brand">{{ product.brand.description }}</p>
                <p class="article">
                  <b>{{ product.article }}</b>
                </p>
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="mobileWrapper">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let product" class="tdWrapper">
            <div class="productMobileMedia" *ngIf="movingRouteMode">
              <div class="hoverImg">
                <div *ngIf="!getImg(product)" class="no-photo">
                  <mat-icon>photo_camera</mat-icon>
                </div>
                <img *ngIf="getImg(product)" [src]="getImg(product)" class="thumbImg" alt="" />
              </div>
            </div>
            <div class="mobileWrapper">
              <p class="description">{{ product.description }}</p>
            </div>
            <div class="mobileMainInfoHolder">
              <p class="brand">{{ product.brand.description }}</p>
              <p class="article">
                <b>{{ product.article }}</b>
              </p>
            </div>
            <div class="whCell">
              <div class="whQuanWrapper">
                <div
                  *ngFor="let wh of sortStock(product)"
                  matTooltip="{{ wh.warehouse.description }} · {{ movingRouteMode ? 'На складе' : 'Свободно' }}: {{ getStockQuantity(wh) }}"
                  class="stockCell {{ getStockQuantity(wh) > 0 ? 'myStock' : 'otherStock' }}"
                >
                  {{ getStockQuantity(wh) }}
                </div>
              </div>
              <span>{{ getWarehouse(product)?.cell }}</span>
            </div>
            <div class="routeStockMobile" *ngIf="movingRouteMode">
              <div class="routeStock" [ngClass]="getMovingStockClass(product, 'from')">
                <span>{{ getMovingWarehouseLabel(movingWarehouseFrom, 'Откуда') }}</span>
                <strong>
                  {{ getMovingCurrentStock(product, movingWarehouseFrom) | number: '1.0-2' }}
                  ->
                  {{ getMovingStockAfter(product, 'from') | number: '1.0-2' }}
                </strong>
                <small *ngIf="getMovingStockCell(product, movingWarehouseFrom)">
                  {{ getMovingStockCell(product, movingWarehouseFrom) }}
                </small>
              </div>
              <div class="routeStock" [ngClass]="getMovingStockClass(product, 'to')">
                <span>{{ getMovingWarehouseLabel(movingWarehouseTo, 'Куда') }}</span>
                <strong>
                  {{ getMovingCurrentStock(product, movingWarehouseTo) | number: '1.0-2' }}
                  ->
                  {{ getMovingStockAfter(product, 'to') | number: '1.0-2' }}
                </strong>
                <small *ngIf="getMovingStockCell(product, movingWarehouseTo)">
                  {{ getMovingStockCell(product, movingWarehouseTo) }}
                </small>
              </div>
            </div>
            <div class="priceWrapper">
              <span>{{ supportService.formatMoney(product.price) }}</span>
              <span>
                {{ supportService.formatMoney(product.retail) }}
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="receive">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let product">
            <button mat-stroked-button color="primary" type="button" [disabled]="!canChooseReceivingProduct"
              (click)="chooseReceivingProduct(product)" [attr.aria-label]="'Добавить ' + product.article + ' в приёмку'">
              <mat-icon>add</mat-icon> Добавить
            </button>
          </td>
        </ng-container>
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? toggleRow(row) : null"
              [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Position Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let prod">
            <a [routerLink]="['/product', prod.id]" target="_blank">
              {{ prod.id }}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="img">
          <th mat-header-cell *matHeaderCellDef>Фото</th>
          <td mat-cell *matCellDef="let prod">
            <button *ngIf="getImg(prod) as imageUrl; else noProductPhoto" type="button"
              class="productPhoto" matTooltip="Увеличить фото"
              [attr.aria-label]="'Открыть фото: ' + prod.description"
              (click)="$event.stopPropagation(); openProductPhotos(prod)">
              <img [src]="imageUrl" [alt]="prod.description" loading="lazy"
                (error)="handleImageError(imageUrl)" />
            </button>
            <ng-template #noProductPhoto>
              <span class="productPhoto productPhoto--empty" matTooltip="Нет фото" role="img" aria-label="Нет фото">
                <mat-icon>image_not_supported</mat-icon>
              </span>
            </ng-template>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Наименование</th>
          <td mat-cell *matCellDef="let prod" class="name" (click)="receivingMode ? chooseReceivingProduct(prod) : toggleRow(prod)">
            {{ prod.description }}
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="brand">
          <th mat-header-cell *matHeaderCellDef>Производитель</th>
          <td mat-cell *matCellDef="let prod">
            {{ prod.brand?.description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="barcode">
          <th mat-header-cell *matHeaderCellDef>Штрихкод</th>
          <td mat-cell *matCellDef="let prod">{{ prod.barcode }}</td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="article">
          <th mat-header-cell *matHeaderCellDef>Артикул</th>
          <td mat-cell *matCellDef="let prod">{{ prod.article }}</td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef>Цена</th>
          <td mat-cell *matCellDef="let prod">
            {{ supportService.formatMoney(prod.price) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="retail">
          <th mat-header-cell *matHeaderCellDef>Цена</th>
          <td
            mat-cell
            matTooltip="{{ supportService.formatMoney(prod.price) }}"
            matTooltipPosition="left"
            *matCellDef="let prod"
          >
            {{ supportService.formatMoney(prod.retail) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="stock">
          <th mat-header-cell *matHeaderCellDef>Свободно</th>
          <td mat-cell *matCellDef="let product">
            <div class="stockWrapper">
              <div
                *ngFor="let wh of sortStock(product)"
                matTooltip="{{ wh.warehouse.description }} · {{ movingRouteMode ? 'На складе' : 'Свободно' }}: {{ getStockQuantity(wh) }}"
                class="stockCell {{ getStockQuantity(wh) > 0 ? 'myStock' : 'otherStock' }}"
              >
                {{ getStockQuantity(wh) }}
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="movingFromStock">
          <th mat-header-cell *matHeaderCellDef>Откуда</th>
          <td mat-cell *matCellDef="let product">
            <div class="routeStock" [ngClass]="getMovingStockClass(product, 'from')">
              <span>{{ getMovingWarehouseLabel(movingWarehouseFrom, 'Откуда') }}</span>
              <strong>
                {{ getMovingCurrentStock(product, movingWarehouseFrom) | number: '1.0-2' }}
                ->
                {{ getMovingStockAfter(product, 'from') | number: '1.0-2' }}
              </strong>
              <small *ngIf="getMovingStockCell(product, movingWarehouseFrom)">
                {{ getMovingStockCell(product, movingWarehouseFrom) }}
              </small>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="movingToStock">
          <th mat-header-cell *matHeaderCellDef>Куда</th>
          <td mat-cell *matCellDef="let product">
            <div class="routeStock" [ngClass]="getMovingStockClass(product, 'to')">
              <span>{{ getMovingWarehouseLabel(movingWarehouseTo, 'Куда') }}</span>
              <strong>
                {{ getMovingCurrentStock(product, movingWarehouseTo) | number: '1.0-2' }}
                ->
                {{ getMovingStockAfter(product, 'to') | number: '1.0-2' }}
              </strong>
              <small *ngIf="getMovingStockCell(product, movingWarehouseTo)">
                {{ getMovingStockCell(product, movingWarehouseTo) }}
              </small>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="cell">
          <th mat-header-cell *matHeaderCellDef>Адрес</th>
          <td mat-cell *matCellDef="let product">
            {{ getWarehouse(product)?.cell }}
          </td>
        </ng-container>

        <ng-container matColumnDef="priceControl">
          <th mat-header-cell *matHeaderCellDef>Цена в документе</th>
          <td mat-cell *matCellDef="let prod">
            <mat-form-field *ngIf="changeRow || documentEditMode" class="inputControl" appearance="standard">
              <mat-label>Цена</mat-label>
              <input
                matInput
                placeholder="Цена"
                (input)="handleChangePrice(prod)"
                [formControl]="getPriceControl(prod)"
              />
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="quanControl">
          <th mat-header-cell *matHeaderCellDef>Кол-во в документе</th>
          <td mat-cell *matCellDef="let prod">
            <mat-form-field *ngIf="changeRow || documentEditMode" class="inputControl" appearance="standard">
              <mat-label>Кол-во</mat-label>
              <input
                matInput
                placeholder="Кол-во"
                (input)="handleChangeQuan(prod)"
                [formControl]="getQuanControl(prod)"
                type="number"
              />
            </mat-form-field>
          </td>
        </ng-container>
        <ng-conatainer matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let prod">
            <button mat-icon-button (click)="openPrintDialog(prod)">
              <mat-icon>print</mat-icon>
            </button>
          </td>
        </ng-conatainer>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          #keyboardRow
          [attr.tabindex]="keyboardMode ? (keyboardActiveId === row.id ? 0 : -1) : null"
          [class.keyboard-active]="keyboardMode && keyboardActiveId === row.id"
          (focus)="keyboardMode && (keyboardActiveId = row.id)"
          (keydown)="onResultKeyboard($event, row)"
          *matRowDef="let row; let i = index; columns: displayedColumns"
          class="{{ i % 2 === 0 ? 'evenRow' : 'oddRow' }}"
        ></tr>
      </table>
    </div>
  </div>
</div>
